// Adapted from: https://www.cssscript.com/easy-sliding-drawer/

const drawer = () => {
  /**
  * Element.closest() polyfill
  * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
  */

  if (! Element.prototype.closest) {
    if (! Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector
      || Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = (str) => {
      const el = this;
      let ancestor = this;
      if (! document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(str)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (null !== ancestor);
      return null;
    };
  }

  //
  // Settings
  //
  const settings = {
    speedOpen: 50,
    speedClose: 350,
    activeClass: 'is-active',
    visibleClass: 'is-visible',
    selectorTarget: '[data-drawer-target]',
    selectorTrigger: '[data-drawer-trigger]',
    selectorClose: '[data-drawer-close]',
  };

  //
  // Methods
  //
  // Toggle accessibility
  const toggleaccessibility = (event) => {
    // eslint-disable-next-line no-console
    console.log(event);
    if (null !== event) {
      if ('true' === event.getAttribute('aria-expanded')) {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    }
  };

  // Open Drawer
  const openDrawer = (trigger) => {
    // Find target
    const target = document.getElementById(trigger.getAttribute('aria-controls')); // eslint-disable-line max-len
    // Make it active
    target.classList.add(settings.activeClass);
    // Make body overflow hidden so it's not scrollable
    document.documentElement.style.overflow = 'hidden';
    // Toggle accessibility
    toggleaccessibility(trigger);
    // Make it visible
    setTimeout(() => {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
    document.querySelector('.drawer__close').focus();
  };

  // Close Drawer
  const closeDrawer = (event) => {
    // Find target
    const closestParent = event.closest(settings.selectorTarget);
    const childrenTrigger = document.querySelector(`[aria-controls=" ${closestParent.id} "`); // eslint-disable-line max-len
    // Make it not visible
    closestParent.classList.remove(settings.visibleClass);
    // Remove body overflow hidden
    document.documentElement.style.overflow = '';
    // Toggle accessibility
    toggleaccessibility(childrenTrigger);
    // Make it not active
    setTimeout(() => {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  // Click Handler
  const clickHandler = (event) => {
    // Find elements
    const toggle = event.target;
    const open = toggle.closest(settings.selectorTrigger);
    const close = toggle.closest(settings.selectorClose);
    // Open drawer when the open button is clicked
    if (open) {
      openDrawer(open);
    }
    // Close drawer when the close button (or overlay area) is clicked
    if (close) {
      closeDrawer(close);
    }
    // Prevent default link behavior
    if (open || close) {
      event.preventDefault();
    }
  };

  // Keydown Handler, handle Escape button
  const keydownHandler = (event) => {
    if ('Escape' === event.key || 27 === event.keyCode) {
      // Find all possible drawers
      const drawers = document.querySelectorAll(settings.selectorTarget);
      // Find active drawers and close them when escape is clicked
      for (let i = 0; i < drawers.length; i += 1) {
        if (drawers[i].classList.contains(settings.activeClass)) {
          closeDrawer(drawers[i]);
        }
      }
    }
  };

  //
  // Inits & Event Listeners
  //
  document.addEventListener('click', clickHandler, false);
  document.addEventListener('keydown', keydownHandler, false);
  document.querySelectorAll('.hbg-view-cart-button').forEach((item) => item.addEventListener('click', () => openDrawer(document.querySelector(settings.selectorTrigger)))); // eslint-disable-line max-len

  // if tabs out of checkout or shift tabs out of close button, go to cart element
  document.addEventListener('keyup', (e) => {
    if ('Tab' === e.key && e.shiftKey && undefined !== e.currentTarget && undefined !== e.currentTarget.classList && e.currentTarget.classList.contains('checkout')) { // eslint-disable-line max-len
      document.querySelector('.checkout').focus();
    } else if ('Tab' === e.key && undefined !== e.currentTarget && undefined !== e.currentTarget.classList && e.currentTarget.classList.contains('checkout')) { // eslint-disable-line max-len
      document.querySelector('.drawer__close').focus();
    }
  });
};

window.onload = drawer();
